import React, { lazy } from "react";
import { useParams } from "react-router-dom";
import RequireAuth from "./RequireAuth";
import lazyLoad from "./lazyLoad";
import { PERMISSIONS } from "../utils/Permissions";
import { getFlag } from "../v2/core/flags";
import { useV2Toggle } from "../context/experienceToggleContext";

const MerchantDetail = lazyLoad(lazy(() => import("../Pages/MerchantDetail")));
const UserDetailV2 = lazyLoad(lazy(() => import("../v2/pages/User/UserDetailV2")));

const MerchantDetailWrapper = () => {
  const { userType } = useParams();
  const { preferV2 } = useV2Toggle();
  const useV2 = getFlag("USE_V2_USER") && !!preferV2;

  const getPermission = (userType) => {
    const map = {
      individual: PERMISSIONS.MERCHANT_INDIVIDUAL_MERCHANT,
      business: PERMISSIONS.MERCHANT_BUSINESS_MERCHANT,
      basic_user: PERMISSIONS.MERCHANT_MIN_KYC_USER,
      ncmc_user: PERMISSIONS.MERCHANT_NCMC_USER,
      fos_user: PERMISSIONS.MERCHANT_FOS_USER,
    };
    return map[userType] || "UNKNOWN_PERMISSION";
  };

  const requiredPermission = getPermission(userType);

  return (
    <RequireAuth requiredPermission={requiredPermission} useV2Layout={useV2}>
      {useV2 ? <UserDetailV2 /> : <MerchantDetail />}
    </RequireAuth>
  );
};

export default MerchantDetailWrapper;
